/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetUsersResponseItem,
    GetUsersResponseItemFromJSON,
    GetUsersResponseItemFromJSONTyped,
    GetUsersResponseItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetUsersResponse
 */
export interface GetUsersResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersResponse
     */
    dividers: boolean;
    /**
     * 
     * @type {Array<GetUsersResponseItem>}
     * @memberof GetUsersResponse
     */
    users: Array<GetUsersResponseItem>;
}

export function GetUsersResponseFromJSON(json: any): GetUsersResponse {
    return GetUsersResponseFromJSONTyped(json, false);
}

export function GetUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUsersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dividers': json['dividers'],
        'users': ((json['users'] as Array<any>).map(GetUsersResponseItemFromJSON)),
    };
}

export function GetUsersResponseToJSON(value?: GetUsersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dividers': value.dividers,
        'users': ((value.users as Array<any>).map(GetUsersResponseItemToJSON)),
    };
}


